const MAX_MESSAGE_LENGTH = 1200;
const MAX_STACK_LENGTH = 8000;
let installed = false;

function normalizeMessage(input) {
  const text = typeof input === 'string' ? input : (input?.message || String(input || 'Unknown client error'));
  return text.slice(0, MAX_MESSAGE_LENGTH);
}

function normalizeStack(input) {
  const stack = typeof input === 'string' ? input : (input?.stack || '');
  return stack.slice(0, MAX_STACK_LENGTH);
}

function buildPayload(source, errorLike, context = {}) {
  return {
    source,
    message: normalizeMessage(errorLike),
    stack: normalizeStack(errorLike),
    pathname: typeof window !== 'undefined' ? window.location.pathname : '',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    context,
  };
}

function sendClientError(payload) {
  try {
    const body = JSON.stringify(payload);
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' });
      const queued = navigator.sendBeacon('/api/client-errors', blob);
      if (queued) return;
    }

    fetch('/api/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {
      // Intentionally ignore client-side log transport failures.
    });
  } catch (_) {
    // Intentionally ignore client-side log transport failures.
  }
}

// Manually report an error that never reaches window.onerror. React render crashes caught by an
// error boundary are the main case — React does not re-throw those to the window, so without this
// they would be invisible to the backend log entirely.
export function reportClientError(source, errorLike, context = {}) {
  sendClientError(buildPayload(source, errorLike, context));
}

export function installClientErrorLogging() {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    const err = event.error || event.message || 'Unhandled window error';
    sendClientError(buildPayload('window.error', err, {
      filename: event.filename || '',
      lineno: Number(event.lineno) || 0,
      colno: Number(event.colno) || 0,
    }));
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    sendClientError(buildPayload('window.unhandledrejection', reason, {
      reasonType: typeof reason,
    }));
  });
}
